import { createAppTheme } from './createAppTheme';

export const darkTheme = createAppTheme('dark');
